export type Opaque<K, T> = T & { __TYPE__: K }
/* Opaque types to distinguish various serialized forms of sense lists */
export type SerializedPhrase = Opaque<'SerializedPhrase', string>
export type Sense = Opaque<'Sense', string>
export type Phrase = Sense[]
export type Alternatives = Phrase[]
export type SerializedAlternatives = Opaque<'SerializedAlternatives', string>

export interface DocSearchTerm {
	label: string
	alts: string[]
	uri?: string
	sense: Sense
}

export const joinPhrase = (phrase: Phrase) => phrase.join('/') as SerializedPhrase
export const splitPhrase = (phrase: SerializedPhrase) => phrase.split('/') as unknown as Sense[]

export const joinAlternatives = (phrases: SerializedPhrase[]) => phrases.join(',') as SerializedAlternatives
export const splitAlternatives = (alts: SerializedAlternatives) => alts.split(',') as unknown as SerializedPhrase[]

export type TUI = Opaque<'TUI', string>

export interface DSSuggestion {
	'suggestion/key': Sense
	'suggestion/label': string
	'suggestion/tuis': TUI[]
	'suggestion/definitions': string[]
	'suggestion/weight': number
}

export interface DACachedSuggestion {
	id: DSSuggestion['suggestion/key']
	label: DSSuggestion['suggestion/label']
	semanticTypes: DSSuggestion['suggestion/tuis']
	definition: DSSuggestion['suggestion/definitions']
	score: number
}

export interface DATermSummary {
	[key: string]: any
	id: string
	definition: string
	semanticTypes: TUI[]
	label: string
	labels: string[]
}

export interface DAUsageByLabel {
	id: string
	label: string
	score: number
}

export type TermType = 'intervention' | 'outcome' | 'characteristic'

export interface DATermUsageSuggestion extends DAUsageByLabel {
	definition: DATermSummary['definition']
	suggestion: DATermSummary['semanticTypes']
	type: TermType
}

export interface DASuggestion extends Omit<DACachedSuggestion, 'id'> {
	id: SerializedPhrase
	ids?: (DACachedSuggestion['id'] | SerializedPhrase | string)[]
	semanticTypes: TUI[]
	type: TermType
	score: number
}

export type QueryTermType = 'intervention' | 'outcome' | 'condition'

export interface QueryAnnotation extends Omit<DASuggestion, 'type'> {
	start: number
	end: number
	preferredLabel: string
	fromText: boolean
	type: QueryTermType
}

export type QueryAnnotations = (string | QueryAnnotation)[]

export interface QueryAlternative {
	annotations: string[]
	interventionalScore: number
}

export type ParsedQuery = {
	annotations: QueryAnnotations
	interventionalScore: number
	alternatives: QueryAlternative[]
}